import { useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import PasswordResetForm from './PasswordResetForm';

type AuthMode = 'signin' | 'signup' | 'reset';

type AuthDialogProps = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly initialMode?: AuthMode;
};

const AuthDialog = ({ open, onClose, initialMode = 'signin' }: AuthDialogProps) => {
  const [mode, setMode] = useState<AuthMode>(initialMode);

  const handleClose = () => {
    onClose();
    // Reset to sign in mode after closing
    setTimeout(() => setMode('signin'), 300);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 4 }}>
        {mode === 'signin' && (
          <SignInForm
            onSwitchToSignUp={() => setMode('signup')}
            onSwitchToReset={() => setMode('reset')}
            onClose={handleClose}
          />
        )}
        {mode === 'signup' && (
          <SignUpForm onSwitchToSignIn={() => setMode('signin')} onClose={handleClose} />
        )}
        {mode === 'reset' && (
          <PasswordResetForm
            onSwitchToSignIn={() => setMode('signin')}
            onClose={handleClose}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AuthDialog;
